import "core-js/modules/esnext.global-this.js";
// src/util/global.js
var actualGlobal;

if (typeof globalThis !== "undefined") {
  actualGlobal = globalThis;
} else if (typeof window !== "undefined") {
  actualGlobal = window;
} else if (typeof global !== "undefined") {
  actualGlobal = global;
} else if (typeof self !== "undefined") {
  actualGlobal = self;
} else {
  actualGlobal = {};
}

var global_default = actualGlobal; // src/middleware/observable.js

var observable_default = function observable_default() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var Observable = opts.implementation || global_default.Observable;

  if (!Observable) {
    throw new Error("`Observable` is not available in global scope, and no implementation was passed");
  }

  return {
    onReturn: function onReturn(channels, context) {
      return new Observable(function (observer) {
        channels.error.subscribe(function (err) {
          return observer.error(err);
        });
        channels.progress.subscribe(function (event) {
          return observer.next(Object.assign({
            type: "progress"
          }, event));
        });
        channels.response.subscribe(function (response) {
          observer.next(Object.assign({
            type: "response"
          }, response));
          observer.complete();
        });
        channels.request.publish(context);
        return function () {
          return channels.abort.publish();
        };
      });
    }
  };
};

export { observable_default };